<template>
	<div class="loginPage">
		<template v-if="orgid == 'aa45263b-96fc-11f1-9985-005056924926'">
			<ssyLogin :formLoginData="form?.admin?.school?.list" />
		</template>
		<template v-else>
			<div class="lp_left">
				<img :src="showLoginMessage.banner" />
			</div>
			<div class="lp_right"  :class="{'lp_right_mobile': logIdentity == 0 }">
				<div
					v-if="allowOrgList.findIndex((i) => i.area) == -1 && steps != 2 && logIdentity == 0"
					@click="backVersion"
					class="Version"
				>
					<span v-if="!cocoNoteType">{{ lang.Returnoldversion }}</span>
					<span v-else>{{ this.typePageName }}</span>
				</div>
				<div class="lp_r_box" v-loading="nextStepsLoading">
					<div class="lp_r_b_logo">
						<div>
							<el-image
								v-if="showLoginMessage.logo"
								style="width: 35px; height: 35px; border-radius: 50%"
								:src="showLoginMessage.logo"
							></el-image>
						</div>
						<div
							style="
								width: 100%;
								display: flex;
								justify-content: space-between;
								align-items: center;
							"
						>
							<div v-if="steps == 1">
								<div class="lp_r_b_logo_name" v-if="showLoginMessage.name">{{
									showLoginMessage.name
								}}</div>
								<span style="margin: 0" v-else>{{ lang.KekeleboPlatform }}</span>
							</div>
							<div v-if="steps == 2">
								<div style="margin-left: 10px" v-if="!cocoNoteCid">{{ codeRes.school }} - {{ codeClassName }}</div>
								<div style="margin-left: 10px" v-if="cocoNoteCid && cocoNoteName">{{ cocoNoteName }}</div>
							</div>
							<div
								v-if="steps == 2 && !cocoNoteCid"
								style="cursor: pointer"
								@click="(steps = 1), (stuInfoCode = {})"
							>
								<i style="font-size: 30px" class="el-icon-back"></i>
							</div>
						</div>
					</div>
					<template v-if="steps == 1">
						<span
							v-if="['default', 'weChat', 'orgL', 'code','code2'].includes(loginType)"
							style="display: flex;justify-content: space-between;align-items: first baseline;"
							>
							<span v-if="!cocoNoteType">{{ lang.login }}</span>
							<span v-else>{{ this.typePageName }}</span>
							<!-- 返回到选择身份 -->
							<div v-if="logIdentity != 0" @click="backIDyData" class="backIDy">{{ lang.Reidentity }}</div>
						</span>
						
						
						<!-- 选择身份登录页  -->
						<div class="logIdy" v-if="logIdentity == 0">
							<div>
								{{ lang.chooseidentity }}
							</div>
							<div style="display: flex;gap: 20px;">
								<div class="logIdImg"  @click="logIdentity = 1">
									<img src="../../assets/login/logTea.svg"  alt="">
									<span>{{ lang.teacher }}</span>
								</div>
								<div class="logIdImg" v-if="this.cocoNoteType != 'classroomOb'"  @click="logIdentity = 2,getData( !cocoNoteType ? 'code' : 'default')">
									<img src="../../assets/login/logStu.svg" alt="">
									<span>{{ lang.student }}</span>
								</div>
							</div>
						</div>
						<!-- 登录页 -->
						<template v-else>
							<span v-if="['bind'].includes(loginType)">
								<!-- 绑定账户 -->
								{{ lang.Bindaccount }}</span>
							<div class="lp_r_b_formArea" >
								<!-- 微信绑定，账号登录，组织号登录 -->
								<div
									class="fa_input"
									v-if="['default', 'bind', 'orgL'].includes(loginType)"
								>
									<div
										class="fa_i_item"
										style="position: relative"
										v-if="loginType == 'orgL'"
									>
										<span>{{ lang.OrganizationNumber }}</span>
										<div>
											<input
												type="text"
												:placeholder="lang.enterorgnumber"
												v-model.trim="SuffixData"
												@input="getSuffix"
											/>
										</div>
										<div
											style="
												border: none;
												font-size: 12px;
												position: absolute;
												left: 0;
												bottom: -70%;
											"
											v-if="SuffixData.trim()"
										>
											{{ orginfo.length ? orginfo[0].name : lang.schoolnotexist }}
										</div>
									</div>
									<div class="fa_i_item">
										<span>{{ lang.account }}</span>
										<div>
											<input
												type="text"
												:placeholder="lang.enteraccount"
												v-model.trim="account"
												@input="inpGetAccOrgName"
												@keyup.enter="loginFn"
											/>
										</div>
									</div>

									<div class="fa_i_item" v-if="loginType == 'default' || loginType == 'bind'" >
										<span>{{ lang.organization }}</span>
										<div v-loading="inpGetAccOrgNameloading">
											<input
												v-if="accOrgName.length == 0"
												disabled
												type="text"
												:placeholder="lang.Identifyaccount"
											/>
											<input
												v-else-if="accOrgName.length == 1"
												disabled
												type="text"
												:placeholder="lang.Identifyaccount"
												:value="accOrgName[0].ou"
											/>
											<el-select
												v-else
												v-model.trim="org"
												:placeholder="lang.selectlogorg"
											>
												<el-option
													v-for="item in accOrgName"
													:key="item.Uorg"
													:label="item.ou"
													:value="item.Uorg"
												>
												</el-option>
											</el-select>
										</div>
									</div>

									<div class="fa_i_item">
										<span>{{ lang.password }}</span>
										<div class="psdg">
											<el-input
												:type="showPassword ? 'text' : 'password'"
												:placeholder="lang.enterpassword"
												v-model="password"
												suffix-icon
												@keyup.enter.native="loginFn">
													<i slot="suffix" @click="showPassword = !showPassword">
														<img
															v-if="showPassword"
															class="input_icon"
															src="@/assets/login/ico_eyes.png"
															/>
														<img
															v-else
															class="input_icon"
															src="@/assets/login/ico_show_pwd.png"
														/>
													</i>
											</el-input>
											<!-- <input
												type="password"
												:placeholder="lang.enterpassword"
												v-model="password"
												@keyup.enter="loginFn"
											/> -->
										</div>
									</div>
								</div>
								<!-- 微信登录  -->
								<div class="fa_weChat" v-if="['weChat'].includes(loginType)">
									<div id="QRcode" class="QRcode" ref="QRcode"></div>
									<!-- @click="loginType = 'bind'" -->
								</div>
								<!-- 随机码登录  -->
								<div class="fa_input" v-if="['code'].includes(loginType)">
									<div class="fa_i_item" style="position: relative">
										<span v-if="prefixL == 'liyuan_'">{{ lang.SelectCampus }}</span>
										<span v-else>{{ lang.OrganizationNumber }}</span>
										<!-- v-if="prefixL == 'liyuan_'" -->
										<div v-if="prefixL == 'liyuan_'">
											<el-select
												v-loading="Codeloading"
												@change="getSuffix"
												v-model.trim="SuffixData"
												:placeholder="lang.Pleaseselect"
											>
												<el-option
													v-for="item in CodeOptions"
													:key="item.code"
													:label="item.name"
													:value="item.code"
												>
												</el-option>
											</el-select>
										</div>
										<div v-else>
											<input
												type="text"
												:placeholder="lang.Pleaseenter"
												v-model.trim="SuffixData"
												@input="getrandomcodeSuffix"
											/>
										</div>
										<div
											style="
												border: none;
												font-size: 12px;
												position: absolute;
												left: 0;
												bottom: -70%;
											"
											v-if="SuffixData.trim() && prefixL != 'liyuan_'"
										>
											{{ orginfo.length ? orginfo[0].name : lang.schoolnotexist }}
										</div>
									</div>

									<div class="fa_i_item">
										<span>{{ lang.randomcode }}</span>
										<div>
											<input
												type="text"
												:placeholder="lang.Pleaseenter"
												v-model.trim="icode"
												@keyup.enter="nextSteps"
											/>
										</div>
									</div>
								</div>
								<!-- 随机码登录2 -->
								<div class="fa_input" v-if="['code2'].includes(loginType)">
									<div class="fa_i_item" style="position: relative">
										<span>{{ lang.randomcode }}</span>
										
										<div>
											<input
												type="text"
												:placeholder="lang.Pleaseenter"
												v-model.trim="SuffixData"
												@keyup.enter="nextSteps2"
											/>
										</div>
									</div>
								</div>
							</div>
							<!-- 登录按钮区域开始 -->
							<div
								class="lp_r_b_btn"
								v-if="['code'].includes(loginType)"
								@click="nextSteps"
							>
								{{ lang.confirm }}
							</div>
							<div
								class="lp_r_b_btn"
								v-if="['code2'].includes(loginType)"
								@click="nextSteps2"
							>
								{{ lang.confirm }}
							</div>
							<div
								class="lp_r_b_btn"
								v-if="['default', 'orgL'].includes(loginType)"
								@click="loginFn"
								v-loading="loading"
							>
								{{ lang.SignIn }}
							</div>
							<div
								class="lp_r_b_btn"
								v-if="loginType == 'weChat'"
								style="opacity: 0; cursor: default"
							>
								{{ lang.Accpaslogin }}
							</div>
							<div class="btn_box" v-if="loginType == 'bind'">
								<div class="lp_r_b_btn" @click="loginFn" v-loading="loading">
									{{ lang.Confirmbinding }}
								</div>
								<div class="lp_r_b_btn" @click="loginType = 'default'">
									{{ lang.Returnlogin }}
								</div>
							</div>
							<!-- 登录按钮区域结束 -->
							<div class="lp_r_b_line">
								<template
									v-if="['default', 'weChat', 'orgL', 'code','code2'].includes(loginType)"
								>
									<div></div>
									<span>{{ lang.Otherlogin }}</span>
									<div></div>
								</template>
							</div>
							<div class="lp_r_b_iconBtn">
								<!-- v-if="['default', 'weChat', 'orgL', 'code','code2'].includes(loginType) && logIdentity == 2 && prefixL != 'liyuan_'" -->

								<div
									v-show="false"
									@click="getData('code2')"
								>
									<el-tooltip
										effect="dark"
										:content="lang.Rancodelogin"
										placement="bottom"
									>
										<img
											:src="
												loginType == 'code2'
													? require('../../assets/login/codel.png')
													: require('../../assets/login/code.png')
											"
											:class="[loginType == 'code2' ? 'backWin' : '']"
										/>
									</el-tooltip>
								</div>
								<div
									v-if="
									['default', 'weChat', 'orgL', 'code','code2'].includes(loginType) &&
									logIdentity == 2 &&
									!cocoNoteType"
									@click="getData('code')"
								>
									<!-- v-if="['default', 'weChat', 'orgL', 'code'].includes(loginType)" -->
									<el-tooltip
										effect="dark"
										:content="lang.Rancodelogin"
										placement="bottom"
									>
										<img
											:src="
												loginType == 'code'
													? require('../../assets/login/codel.png')
													: require('../../assets/login/code.png')
											"
											:class="[loginType == 'code' ? 'backWin' : '']"
										/>
									</el-tooltip>
								</div>

								<div
									@click="(loginType = 'orgL'), (org = '')"
									v-if="
										['default', 'weChat', 'orgL', 'code','code2'].includes(loginType) &&
										allowOrgList.findIndex((i) => i.area) == -1 && logIdentity == 1
									"
								>
									<el-tooltip
										effect="dark"
										:content="lang.OrgIDLogin"
										placement="bottom"
									>
										<img
											style="width: 32px; object-fit: cover"
											:src="
												loginType == 'orgL'
													? require('../../assets/login/zzl.svg')
													: require('../../assets/login/orgh.svg')
											"
											:class="[loginType == 'orgL' ? 'backWin' : '']"
										/>
									</el-tooltip>
								</div>

								<div
									@click="wechatLogin"
									v-if="['default', 'weChat', 'orgL', 'code','code2'].includes(loginType) && logIdentity == 1"
								>
									<el-tooltip
										effect="dark"
										:content="lang.WeChatLogin"
										placement="bottom"
									>
										<img
											:src="
												loginType == 'weChat'
													? require('../../assets/login/wxl.svg')
													: require('../../assets/login/wxh.svg')
											"
											:class="[loginType == 'weChat' ? 'backWin' : '']"
										/>
									</el-tooltip>
								</div>

								<div
									@click="Seldefault"
									v-if="['default', 'weChat', 'orgL', 'code','code2'].includes(loginType)"
								>
									<el-tooltip
										effect="dark"
										:content="lang.Accpaslogin"
										placement="bottom"
									>
										<img
											:src="
												loginType == 'default'
													? require('../../assets/login/zhl.svg')
													: require('../../assets/login/zhh.svg')
											"
											:class="[loginType == 'default' ? 'backWin' : '']"
										/>
									</el-tooltip>
								</div>
							</div>
						</template>

					</template>
					<div class="stuPage" v-if="steps == 2">
						<div>{{ lang.choosename }}</div>
						<div class="tep">
							<div class="nameList">
								<div class="stuList" v-for="op in classJuri" :key="op.id">
									<p class="stuListTit" :id="'group-'+op.id">{{ op.id }}</p>
									<div
										v-for="i in op.child"
										:key="i.userid"
										:class="[stuInfoCode.userid == i.userid ? 'stuback' : '','nameModule']"
										@click="selAcc(i)"
									>
										<el-tooltip effect="dark" :content="i.username" placement="top">
											<span>
												{{ i.username }}
											</span>
										</el-tooltip>
									</div>
								</div>
							</div>
							<div class="Abar">
								<span v-for="op in classJuri" :key="op.id" @click="somp(op.id)">
									{{ op.id }}
								</span>
							</div>
						</div>
						<div v-if="!classJuri.length" class="none">{{ lang.nostudents }}</div>
						<div class="lp_r_b_btn" @click="loginCode" v-loading="loading">
							{{ lang.Confirmlogin }}
						</div>
					</div>
				</div>
			</div>
		</template>
	</div>
</template>
<script>
import { mapActions } from "vuex";
import axios from "axios";
import qs from "qs";
import { API_CONFIG } from "@/common/apiConfig";
import "@/common/wxLogin";
import { getUser, loginOut, GetSuffix } from "@/api/user";
import { myMixin } from "@/mixins/mixin.js";
import pinyin from 'pinyin';
import _ from 'lodash';
import ssyLogin from './ssyLogin.vue';

export default {
	mixins: [myMixin],
	name: "loginPage",
	components: {
		ssyLogin,
	},
	data() {
		return {
			orgid:'', // 组织id
			showPassword:false,
			// 0选择页 1教师 2学生
			logIdentity:0,
			nextStepsLoading:false,
			// 判断显示组织号区域
			SuffixShow: false,
			// 组织号查询区域结果
			SuffixData: "",
			inpGetAccOrgNameloading:false,
			// 获取随机码班级名称
			codeClassName:'',
			orginfo: [],
			codeRes: "",
			CodeOptions: [],
			// 随机码
			icode: "",
			// 根据随机码获取到的课程id
			courseId: "",
			// 随机码登录获取到的课程学生列表
			classJuri: [],
			// 随机码荔园登录获code数据加载框
			Codeloading: false,
			// 随机码登录页面切换
			steps: 1,
			// 随机码选择学生账户信息登录
			stuInfoCode: {},
			// 后缀
			org: "",
			account: "",

			// 查询组织名称 
			accOrgName:[],
			password: "",
			loading: false,
			loginType: "default",
			redirect: this.$route.query["redirect"],
			orgnum: this.$route.query["orgnum"],
			classcode: this.$route.query["classcode"],
			org2:
				this.$route.query["org"] ||
				(window.location.href.includes("/liyuan")
					? window.sessionStorage.getItem("org2")
					: ""),
			oid: this.$route.query["oid"],
			// 组织列表
			OrgOptions: [],
			form: {},
			showName: "",
			oloading: false,
			openid: "",
			cocoNoteType: this.$route.query["type"],
			urlForm: this.$route.query["form"],
			urlState: this.$route.query["state"],
			cocoNoteCid: this.$route.query["courseid"],
			// cocoNoteCid: "da5aa5b7-a98c-11f0-84cf-005056924926",
			cocoNoteCon: {
				banner: require('../../assets/login/image.png'),
				logo: '',
				name: '跨学科学习'
			},
			personCon: {
				banner: 'https://liyuan.cocorobo.cn/img/login2.3d600ff5.jpg',
				logo: '',
				name: '拔尖人才'
			},
			learningCon: {
				banner: 'https://liyuan.cocorobo.cn/img/login2.3d600ff5.jpg',
				logo: '',
				name: '个性化学习'
			},
			classroomObCon: {
				banner: 'https://liyuan.cocorobo.cn/img/login2.3d600ff5.jpg',
				logo: '',
				name: '课堂教学评价'
			},
			typePageName:'',
			cocoNoteName:'',
			uppercaseAlphabet:['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'],
			allowOrgList: [
				{
					area:
						parent.location.href.includes("lyxx") ||
						parent.location.href.includes("liyuan"),
					banner:
						"https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/20250421-1139511745206807965.jpg",
					logo: "https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/image%2051744962188550.svg",
					name: "深圳市福田区荔园小学（荔园教育集团）智慧教育平台",
					list: [
						"3823a6a5-1b6e-11f0-a66a-005056924926",
						"292e34dc-1b6e-11f0-a66a-005056924926",
						"21d6b367-1b6e-11f0-a66a-005056924926",
						"1a1a172d-1b6e-11f0-a66a-005056924926",
						"1197f86b-1b6e-11f0-a66a-005056924926",
						"f235659b-1b6d-11f0-a66a-005056924926",
						"d87b62d3-1b6d-11f0-a66a-005056924926",
						"c25ea59b-1b6d-11f0-a66a-005056924926",
						// "16ace517-b5c7-4168-a9bb-a9e0035df840" //深圳电教馆
					],
				},
			],
		};
	},
	watch: {
		loginType(newValue) {
			if (newValue != "weChat") {
				if (this.$refs.QRcode && this.$refs.QRcode.innerHTML) {
					this.$refs.QRcode.innerHTML = "";
				}
			}
		},
	},
	computed: {
		showLoginMessage() {
			let _result = {
				banner: require("@/assets/login2.jpg"),
				logo: "",
				name: "",
			};
			// try {
			// 	console.log('parent.location.href', parent.location.href);
			// 	console.log('window.location.href', window.location.href);
			// 	console.log('this.$route.query', this.$route.query);
			// } catch (error) {
			// 	console.log('error1111', error);
			// }

			// try {
			// 	console.log('window.topU.location.href', window.topU.location.href);
			// } catch (error) {
			// 	console.log('error2222', error);
			// }
			

			if (this.allowOrgList.findIndex((i) => i.area) != -1) {
				let _index = this.allowOrgList.findIndex((i) => i.area);
				let _obj = this.allowOrgList[_index];
				_result.banner = _obj.banner;
				_result.name = _obj.name;
				_result.logo = _obj.logo;
			} else if (window.location.href.includes('aa45263b-96fc-11f1-9985-005056924926')) {
				_result.banner =  require('@/assets/login/hkl.jpg');
			}else if (this.$region == 'hk' || this.$region == 'com') {
				_result.banner =  require('@/assets/login/hklog.svg');
			} else if (this.cocoNoteType == 'coconote') {
				_result.banner = this.cocoNoteCon.banner;
				_result.name = this.cocoNoteCon.name;
				_result.logo = this.cocoNoteCon.logo;
			} else if (this.cocoNoteType == 'person') {
				_result.banner = this.personCon.banner;
				_result.name = this.personCon.name;
				_result.logo = this.personCon.logo;
			}else if (this.cocoNoteType == 'learning') {
				_result.banner = this.learningCon.banner;
				_result.name = this.learningCon.name;
				_result.logo = this.learningCon.logo;
			}else if (this.cocoNoteType == 'classroomOb') {
				_result.banner = this.classroomObCon.banner;
				_result.name = this.classroomObCon.name;
				_result.logo = this.classroomObCon.logo;
			}

			return _result;
		},
		userRequest() {
			console.log("this.$region", this.$region);

			let _result =
				this.$region == "hk"
					? "https://cloud.api.cocorobo.hk/api/user"
					: this.$region == "com"
					? "https://cloud.api.cocorobo.com/api/user"
					: "https://beta.api.cocorobo.cn/api/user";

			return _result;
		},
	},
	methods: {
		...mapActions({
			login: "user/login",
			logout: "user/logout",
		}),
		// coconote学生登录
		async cocostulog(){
			this.steps = 2
			let params = [
				{
					functionName: API_CONFIG.selectSCourseStudents.functionName,
					cid: this.cocoNoteCid
				},
			];
			try {
				const res = await this.$ajax.post(API_CONFIG.baseUrl, params);
				console.log("data", res.data);
				if (res.data[0].length) {
					this.cocoNoteName = res.data[0][0].title
				}
				this.classJuri = this.groupByName(res.data[0])
				this.nextStepsLoading = false
			} catch (error) {
				this.nextStepsLoading = false
				console.log('error',error);
			}
		},
		// 返回身份登录页后清除数据 
		backIDyData(){
			this.password = '';
			this.org = '';
			this.account = '';
			this.loginType = "default";
			this.SuffixData = '';
			this.icode = '';
			this.logIdentity = 0;
			this.accOrgName = []
		},
		Seldefault(){
			this.loginType = 'default'
			this.SuffixData = ''
			this.org = ''
			this.account=''
			this.accOrgName = []
		},
		somp(val){
			const element = document.getElementById(`group-${val}`);
				if (element) {
					element.scrollIntoView({
						behavior: 'smooth',
						block: 'start'
					});
					
					// 添加视觉反馈
					element.classList.add('highlight');
					setTimeout(() => {
						element.classList.remove('highlight');
					}, 1000);
				}
			// document.getElementById(val).scrollIntoView({
			// 	behavior: 'smooth'
			// });
		},
		// 返回旧版本
		backVersion() {
			console.log(this.$region);
			if (this.cocoNoteType) return console.log('不能返回');
			
			this.$confirm(this.lang.backoldversion, this.lang.tip, {
				confirmButtonText: this.lang.confirm,
				cancelButtonText: this.lang.Cancel,
				type: "warning",
			})
				.then(() => {
					if (this.$region == "beta") {
						window.topU.location.href =
							"https://beta.cloud.cocorobo.cn/index.html";
					} else if (this.$region == "hk") {
						window.topU.location.href = "https://cloud.cocorobo.hk/index.html";
					} else if (this.$region == "com") {
						window.topU.location.href = "https://cloud.cocorobo.com/index.html";
					} else {
						window.topU.location.href = "https://cloud.cocorobo.cn/index.html";
					}
				})
				.catch(() => {});
		},
		// 随机码获取组织后缀
		// async getrandomcodeSuffix() {
		getrandomcodeSuffix: _.debounce(async function() {

			let params = [
				{
					functionName: API_CONFIG.ajax_getliyuanCode.functionName,
					mode: this.SuffixData,
				},
			];
			const res = await this.$ajax.post(API_CONFIG.baseUrl, params);
			let data = [...res.data[0], ...res.data[1]];
			console.log("data", data);

			if (data.length) {
				this.orginfo = data;
				this.org = this.orginfo[0].mail;
			} else {
				this.orginfo = [];
				this.org = "";
			}
		}, 300),

		// 获取组织后缀
		// async getSuffix() {
		getSuffix: _.debounce(async function() {
			if (!this.SuffixData) {
				this.orginfo = [];
				this.org = "";
				return;
			}
			let res = await GetSuffix({ mode: this.SuffixData });
			console.log("res.data[0]", res.data[0]);

			if (res.data[0].length && this.SuffixData) {
				this.orginfo = res.data[0];
				this.org = this.orginfo[0].mail;
			} else {
				this.orginfo = [];
				this.org = "";
			}
		}, 300),
		async loginFn() {
			if (this.loading) return;
			if (this.inpGetAccOrgNameloading && (this.loginType == 'default' || this.loginType == 'bind')) return this.$message.error(this.lang.waitfororg);

			// loginType == orgL为组织号登录
			let str = this.account.replace(/(^\s*)|(\s*$)/g, "");
			console.log('str',str);
			
			// 判断账号是否有后缀
			const regEmail = new RegExp(
				"^[A-Za-z0-9_*-]+@[a-zA-Z0-9_-]+(\\.[a-zA-Z0-9_-]+)+$"
			);
			// "^[A-Za-z0-9_-]+@[a-zA-Z0-9_-]+(\\.[a-zA-Z0-9_-]+)+$"

			if (this.loginType == "default" && !this.org) {
				this.loading = false;
				// 请输入组织号
				if (this.accOrgName.length == 0) {
					
					return this.$message.error(this.prefixL == 'liyuan_' ? this.lang.completeaccountnumber : this.lang.completeaccountnumber2);
				}
				return this.$message.error(this.lang.selectlogorg);
			}

			
			// 组织号页面，没有账号后缀提示需要添加组织号
			if (this.loginType == "orgL" && !this.org && !regEmail.test(str)) {
				this.loading = false;
				// 请输入组织号
				return this.$message.error(this.lang.enterorgnumber);
			}

			this.loading = true;
			if (this.account.length <= 0) {
				this.$message.error(this.lang.enteraccount);
				this.loading = false;
				return;
			}
			if (this.password.length < 6) {
				this.$message.error(this.lang.passwordlength);
				this.loading = false;
				return;
			}
			// 密碼只能為字母、數字或符號
			if (!/^[\x21-\x7E]+$/.test(this.password)) {
				this.$message.error(this.lang.passwordformat);
				this.loading = false;
				return;
			}
			// if (this.loginType != 'orgL') {
			// 返回2就是多账户,荔园提示联系管理员关闭多余账户，非荔园跳转组织号登录
			if (this.loginType == 'orgL') {
				if ((await this.getOrgData()) == 2) {
					this.loading = false;
					return
					// return (this.loginType = "orgL");
				}
			}
			
			// }

			// 荔园平台登录账号进行判断
			if (this.allowOrgList.findIndex((i) => i.area) != -1) {
				// 能到这里就是有账户而且取到后缀了

				// 暂时多余的一步，还是取荔园校区数组（新）
				let _index = this.allowOrgList.findIndex((i) => i.area);
				let _list = this.allowOrgList[_index].list;
				if (
					this.loginType == 'orgL' && this.loginType == 'weChat' && !_list.includes(this.OrgOptions.find((i) => i.Uorg == this.org).id)
				) {
					this.loading = false;
					// 账号不可登录，请使用您的专属网址
					return this.$message.error(this.lang.Accountcannot);
				}
		
				// if ((this.loginType == 'default' || this.loginType == 'bind') && !_list.includes(this.accOrgName.find((i) => i.Uorg == this.org)) && !_list.includes(this.accOrgName.find((i) => i.Uorg == this.org).id)) {
				if ((this.loginType == 'default' || this.loginType == 'bind') && !this.accOrgName.length) {
					this.loading = false;
					// 账号不可登录，请使用您的专属网址
					return this.$message.error(this.lang.Accountcannot2);
				}

				// if (
				// 	this.OrgOptions.find((i) => i.Uorg == this.org) &&
				// 	!_list.includes(this.OrgOptions.find((i) => i.Uorg == this.org).id)
				// ) {
				// 	this.loading = false;
				// // 账号不可登录，请使用您的专属网址
				// 	return this.$message.error(this.lang.Accountcannot);
				// }
			} else {
				// 这个是组织号登录时与账号登录只有一个时
				// 非荔园登录时
				// 取荔园校区list
				let mergedList = this.allowOrgList.reduce((acc, curr) => {
					return [...acc, ...curr.list];
				}, []);
				// let str = this.account.replace(/(^\s*)|(\s*$)/g, "");
				// console.log("regEmail.test(str)", !regEmail.test(str), this.org);

				// 这一步是为了判断登录时，账户是否在组织下有账户问题（但现在获取账户时那部分已经被隐藏，多账号返回数字，这行代码没用了）
				// if (this.OrgOptions.find((i) => i.Uorg == this.org)) {
				// console.log('555',this.OrgOptions.find((i) => i.Uorg == this.org).id);
				if (this.loginType == 'orgL' || this.loginType == 'weChat') {
					if (regEmail.test(str) && this.OrgOptions.find((i) => mergedList.includes(i.id)) && this.OrgOptions.find((i) => mergedList.includes(i.id)).id) {
						console.log('99999999999');
						
						this.loading = false;
						// 账号不可登录，请使用您的专属网址
						return this.$message.error(this.lang.Accountcannot);
					}else if (this.org && this.OrgOptions.find((i) => i.Uorg == this.org) && mergedList.includes(this.OrgOptions.find((i) => i.Uorg == this.org).id)) {
						this.loading = false;
						// 账号不可登录，请使用您的专属网址
						return this.$message.error(this.lang.Accountcannot);
					}
				}
				if ((this.loginType == 'default' || this.loginType == 'bind') && this.accOrgName.find((i) => i.Uorg == this.org) && mergedList.includes(this.accOrgName.find((i) => i.Uorg == this.org).id)) {
					this.loading = false;
					// 账号不可登录，请使用您的专属网址
					return this.$message.error(this.lang.Accountcannot);
				}
				
			}


			let orgValue = this.org ? "@" + this.org : "@cocorobo.cc";
			let email = "";

			// 判断用户输入账户带不带后缀
			if (!regEmail.test(str)) {
				email = str + orgValue;
			} else {
				email = str;
			}
			if (["default", "orgL"].includes(this.loginType)) {
				let params = {};
				try {
					params = {
						geetest_challenge: "",
						geetest_validate: "",
						geetest_seccode: "",
						loginUsername: email.trim(),
						loginPassword: window.btoa(this.password.trim()),
					};
				} catch (e) {
					this.$message.error(this.lang.passwordlength);
					this.loading = false;
					return;
				}
				axios.defaults.withCredentials = true;
				console.log("👇", this.prefixL);
				// this.addOp3('1', "", { type:this.prefixL + "login" }, "success",'0c3735c9-a2ef-11ef-9b30-005056b86db5')
				axios
					.post(this.userRequest, qs.stringify(params))
					.then(async (res) => {
						console.log("this.userRequestres", res);
						let _data = res.data[0][0];
						let userjson = await getUser({ userid: _data.userid });

						const currentDate = new Date();
						if (
							userjson.data[0][0].isLogin1 == 2 ||
							(userjson.data[0][0].isLogin1 &&
							userjson.data[0][0].isLogin1 != 1 &&
							userjson.data[0][0].isLogin1 != 2 &&
							new Date(userjson.data[0][0].isLogin1) < currentDate) ||
							userjson.data[0][0].isLogin2 == 2 ||
							(userjson.data[0][0].isLogin2 != 1 &&
							userjson.data[0][0].isLogin2 != 2 &&
							new Date(userjson.data[0][0].isLogin2) < currentDate) ||
							userjson.data[0][0].state != 1
						) {
							this.loading = false;
							console.log('666');
							this.$message.error(this.lang.accAbnormal)

							return;
						}

						console.log("userjson", userjson);
						if (_data.active === 1) {
							window.localStorage["identity"] = JSON.stringify(_data.identity);

							window.topU.U.UF.Cookie.set("cocoroboLoginType=2");
							window.topU
								? (window.topU.US.userInfo = _data)
								: (window.parent.US.userInfo = _data);
							await this.login();
							this.$message.success(this.lang.Loginsuccessful);
							if (
								userjson.data[0][0].type == 1 &&
								userjson.data[0][0].role == 1 &&
								userjson.data[0][0].rrole == 1 &&
								this.allowOrgList.findIndex((i) => i.area) != -1
							) {
								if (this.urlForm === 'desktop') {
									window.location.href=`cocorobo://auth/callback?apiKey=${userjson.data[0][0].apikey}&state=${this.urlState}&userid=${userjson.data[0][0].userid}&username=${userjson.data[0][0].username}&schoolname=${userjson.data[0][0].schoolName}`;
								} else {
									this.$router.push({ path: "/kanban" });
								}
							} else {
								if (this.urlForm === 'desktop') {
									window.location.href=`cocorobo://auth/callback?apiKey=${userjson.data[0][0].apikey}&state=${this.urlState}&userid=${userjson.data[0][0].userid}&username=${userjson.data[0][0].username}&schoolname=${userjson.data[0][0].schoolName}`;
								} else {
									this.$router.push(
										{ path: this.redirect || "/",
										query: { type: this.cocoNoteType },
									});
								}
							}
							// 浏览器缓存去除随机码登录信息
							window.sessionStorage.removeItem("stuInfoCode");
							this.addOp3(
								"1",
								"",
								{ type: this.prefixL + (userjson.data[0][0].type == 1 ? '_teacher' : '_student') +"login" },
								"success",
								_data.userid
							);
						} else {
							this.$message.error(this.lang.Loginfailed);
						}
						this.loading = false;
					})
					.catch((e) => {
						if (e.response && (e.response.data == "Wrong email or password" || e.response.data == '错误邮箱和密码')) {
							this.$message.error(this.lang.Accerror);
						} else {
							this.$message.error(this.lang.Loginfailed);
						}
						this.loading = false;
					});
			} else if (this.loginType == "bind") {
				// this.$message.info("绑定账号");
				let data = await this.$ajax.post(API_CONFIG.baseUrl2 + "checkOpenId", [
					{ email: email },
				]);
				if (!data.data[0].length) {
					this.$message.error(this.lang.Nocoracc);
					this.loading = false;
					return;
				}
				if (data.data[0][0].thirdpartyid) {
					this.$message.error(this.lang.hasbeenlinked);
					this.loading = false;
					return;
				}

				let params = {};
				try {
					params = {
						geetest_challenge: "",
						geetest_validate: "",
						geetest_seccode: "",
						loginUsername: email.trim(),
						loginPassword: window.btoa(this.password.trim()),
					};
				} catch (e) {
					this.$message.error(this.lang.passwordlength);
					this.loading = false;
					return;
				}
				this.loading = true;
				axios.defaults.withCredentials = true;
				console.log("👇进入进行微信绑定环节");
				axios
					.post(this.userRequest, qs.stringify(params))
					.then(async (res) => {
						console.log("res", res);
						let _data = res.data[0][0];
						let userjson = await getUser({ userid: _data.userid });
						

						const currentDate = new Date();
						if (
							userjson.data[0][0].isLogin1 == 2 ||
							(userjson.data[0][0].isLogin1 &&
							userjson.data[0][0].isLogin1 != 1 &&
							userjson.data[0][0].isLogin1 != 2 &&
							new Date(userjson.data[0][0].isLogin1) < currentDate) ||
							userjson.data[0][0].isLogin2 == 2 ||
							(userjson.data[0][0].isLogin2 != 1 &&
							userjson.data[0][0].isLogin2 != 2 &&
							new Date(userjson.data[0][0].isLogin2) < currentDate) ||
							userjson.data[0][0].state != 1
						) {
							console.log('666');
							this.loading = false;
							this.$message.error(this.lang.accAbnormal)
							return;
						}
						console.log("userjson", userjson);
						if (_data.active === 1) {
							await this.$ajax.post(API_CONFIG.baseUrl2 + "UpdateOpenId", [
								{ userid: _data.userid, openid: this.openid },
							]);
							window.localStorage["identity"] = JSON.stringify(_data.identity);
							this.$message.success(this.lang.Bindingsuc);
							window.topU.U.UF.Cookie.set("cocoroboLoginType=2");
							window.topU
								? (window.topU.US.userInfo = _data)
								: (window.parent.US.userInfo = _data);
							await this.login();
							if (
								userjson.data[0][0].type == 1 &&
								userjson.data[0][0].role == 1 &&
								userjson.data[0][0].rrole == 1 &&
								this.allowOrgList.findIndex((i) => i.area) != -1
							) {
								if (this.urlForm === 'desktop') {
									window.location.href=`cocorobo://auth/callback?apiKey=${userjson.data[0][0].apikey}&state=${this.urlState}&userid=${userjson.data[0][0].userid}&username=${userjson.data[0][0].username}&schoolname=${userjson.data[0][0].schoolName}`;
								} else {
									this.$router.push({ path: "/kanban" });
								}
							} else {
								if (this.urlForm === 'desktop') {
									window.location.href=`cocorobo://auth/callback?apiKey=${userjson.data[0][0].apikey}&state=${this.urlState}&userid=${userjson.data[0][0].userid}&username=${userjson.data[0][0].username}&schoolname=${userjson.data[0][0].schoolName}`;
								} else {
									this.$router.push({ 
										path: this.redirect || "/",
										query: { type: this.cocoNoteType }
									});
								}
							}
							// 浏览器缓存去除随机码登录信息
							window.sessionStorage.removeItem("stuInfoCode");
						} else {
							this.$message.error(this.lang.Bindingfailed);
						}

						this.loading = false;
					})
					.catch((e) => {
						console.log(e);

						if (e.response && e.response.data == "Wrong email or password") {
							this.$message.error(this.lang.Accerror);
						} else {
							this.$message.error(this.lang.Bindingfailed);
						}
						this.loading = false;
					});
			}
		},
		async getLoading() {
			// 检查用户是否已登录
			const hasToken = this.$store.getters.token;
			if (hasToken) {
				// 如果已登录，直接重定向
				this.$router.push({ 
					path: this.redirect || "/",
					query: { type: this.cocoNoteType }
				});
				return;
			}
			const userid = await this.login();
			if (userid) {
				this.$router.push({ 
					path: this.redirect || "/",
					type: this.cocoNoteType 
				});
			}
		},
		// async inpGetAccOrgName(){
		inpGetAccOrgName: _.debounce(async function() {
			if (this.loginType != 'default' && this.loginType != 'bind') return
			this.org = ''
			this.accOrgName = []
			this.inpGetAccOrgNameloading = true

			let params = [
				{
					functionName: this.prefixL == 'liyuan_' ? API_CONFIG.select_liYuanOrgTwo.functionName : API_CONFIG.ajax_liYuanOrg.functionName,
					uname: this.account,
				},
			];
			try {
				const res = await this.$ajax.post(API_CONFIG.baseUrl, params);

				console.log("res", res.data[0]);
				// this.accOrgName = []

				let data = res.data[0]

				if (data.length > 0) {
					data.forEach(e=>{
						e.ou = (e.name ? e.name + ' — ' : '') +  e.schoolName
					})
				}
				this.$nextTick(() => {
					
					if (this.logIdentity == 1 && data && data.length) {
						this.accOrgName = data.filter(e=> e.type == 1)
					}else if (this.logIdentity == 2 && data && data.length) {
						this.accOrgName = data.filter(e=> e.type == 2)
					}else{
						this.accOrgName = data
					}
					this.org = this.accOrgName.length === 1 ? this.accOrgName[0].Uorg : '';
					this.inpGetAccOrgNameloading = false
				});

			} catch (error) {
				this.inpGetAccOrgNameloading = false
			}
			

		}, 300),
		// 输入账号获取组织
		getOrgData() {
			return new Promise((resolve) => {
				let params = [
					{
						functionName: API_CONFIG.ajax_liYuanAcc.functionName,
						uname: this.account,
					},
				];
				this.$ajax
					.post(API_CONFIG.baseUrl, params)
					.then((res) => {
						console.log("res", res);

						this.OrgOptions = res.data[0];

						// 未查询到账户，
						if (this.OrgOptions[0].num == 0){
							this.loading = false
							resolve(2);
							// 未查询到账号，请检查是否填写错误或还未创建账号
							return this.$message.error(
								this.lang.Accnotfound
							);
						}

						// 这一步应该是组织号登录时必须要填组织号时有用，现在没用了---这句话的区域用的（但现在获取账户时那部分已经被隐藏）
						// 有用，组织号登录时就不让他往下走了，防止多账号问题与组织号登录冲突，去除这行影响组织号登录往下执行，
						if (this.loginType == "orgL") return resolve(1);

						if (this.OrgOptions[0].num == 1) {
							this.org = this.OrgOptions[0].Uorg;
						} else {
							// 多账号时
							// liyuan走这里
							if (this.allowOrgList.findIndex((i) => i.area) != -1) {
								// 有多个账号，但没有荔园的，就说明使用错网址了
								if (this.OrgOptions[0].liyuannum == 0) {
									this.$message.error(
										// 账号不可登录，请使用您的专属网址
										this.lang.Accountcannot
									);
									return resolve(2);
								}

								// 那这里就必有荔园账户了 
								try {
									let _index = this.allowOrgList.findIndex((i) => i.area);
									let _list = this.allowOrgList[_index].list;
									// 赋值后缀
									let liyuanAcc = this.OrgOptions.filter((i) =>
										_list.includes(i.id)
									);

									if(liyuanAcc.findIndex(e => e.rrole == 1)){
										this.org = liyuanAcc.filter((i) =>
											i.rrole == 1
										)[0].Uorg
									}else{
										this.$message.error(
											this.lang.liyuanAccMore
										);
										return resolve(2);
									}


								} catch (error) {
									console.log(error);
									this.loading = false
									this.$message.error(
										this.lang.Accountcannot
									);
									return resolve(2);
								}
								
								// this.$message.error(this.lang.liyuanAccMore);
							} else {
								// admin走这里
								// let mergedList = this.allowOrgList.reduce((acc, curr) => {
								// 	return [...acc, ...curr.list];
								// }, []);

								// if (
								// 	this.OrgOptions.filter((i) => !mergedList.includes(i.id))
								// 		.length == 1
								// ){
								// 	this.loading = false
								// 	return this.$message.error(
								// 		// 账号不可登录，请使用您的专属网址
								// 		this.lang.Accountcannot
								// 	);
								// }
								// if (this.OrgOptions[0].liyuannum != 0) {
								// 	this.$message.error(
								// 		// 账号不可登录，请使用您的专属网址
								// 		this.lang.Accountcannot
								// 	);
								// 	return resolve(2);
								// }

								// 该账号须使用“组织号登陆”
								// this.$message.error(this.lang.accountmustOrg);
								
								// this.loginType = "orgL";
								return resolve(2);

							}
						}
						return resolve(1);
					})
					.catch((err) => {
						console.log(err);
					});
			});
		},
		//获取组织或学校的数据，渲染非荔园学校页面
		getOrdOidData() {
			let params = [
				{
					functionName: API_CONFIG.ajax_schoolPermission.functionName, // 调用存储过程的名称
					org: this.org2, //组织id
					oid: this.oid, //学校id
					ar: this.$region
				},
			];
			// 发起请求
			this.$ajax
				.post(API_CONFIG.baseUrl, params)
				.then((res) => {
					let data = res.data[0];
					console.log("data", data);
					this.form = JSON.parse(data[0].json);
					this.showName = this.form.basics.title || data[0].name;
				})
				.catch((err) => {
					console.error("请求失败，错误信息：", err);
				});
		},
		wechatLogin() {
			this.loginType = "weChat";
			this.org = "";
			setTimeout(() => {
				const randomState = Math.random().toString(36).substring(2); // 生成随机状态
				// eslint-disable-next-line no-undef
				new WxLogin({
					self_redirect: true,
					id: "QRcode",
					appid: "wxe9d7fff3c659445f",
					scope: "snsapi_login",
					redirect_uri: encodeURIComponent("https://cocorobo.cn/weixin.html"), //https://liyuan.cocorobo.cn/#/wxTest
					state: randomState,
					style: "black",
					href: "data:text/css;base64,LmltcG93ZXJCb3gge2Rpc3BsYXk6IGZsZXg7fQouaW1wb3dlckJveCAucXJjb2RlIHt3aWR0aDogMjMycHg7IGhlaWdodDogMjMycHh9Ci5pbXBvd2VyQm94IC50aXRsZSB7ZGlzcGxheTogbm9uZTt9Ci5pbXBvd2VyQm94IC5pbmZvIHtkaXNwbGF5OiBub25lO30KLmxvZ2luUGFuZWx7d2lkdGg6MTAwJTtoZWlnaHQ6MTAwJTtkaXNwbGF5OmZsZXg7ZmxleC1kaXJlY3Rpb246Y29sdW1uO2FsaWduLWl0ZW1zOmNlbnRlcjtqdXN0aWZ5LWNvbnRlbnQ6Y2VudGVyO30KLnN0YXR1c19pY29uIHtkaXNwbGF5OiBub25lfQoud2ViX3FyY29kZV9wYW5lbF9hcmVhe2hlaWdodDoxMDAlO3dpZHRoOjEwMCU7ZGlzcGxheTpmbGV4O2FsaWduLWl0ZW1zOmNlbnRlcjtqdXN0aWZ5LWNvbnRlbnQ6Y2VudGVyO30K",
					onReady: function (isReady) {
						console.log(isReady);
					},
				});
				setTimeout(() => {
					let iframe = this.$refs.QRcode.querySelector("iframe");
					iframe.style.width = "100%";
					iframe.style.height = "100%";
				}, 0);
			}, 0);
		},
		// 微信登录
		async getOpenId(openid) {
			console.log('开始微信登录');
			// oiztX1dwR-W2mBJ5HcvaSEB8yKGY
			axios.defaults.withCredentials = false;
			let params = {
				openid: openid,
			};
			this.openid = openid;
			axios.defaults.withCredentials = true;
			axios
				.post(this.userRequest, qs.stringify(params))
				.then(async (res) => {
					console.log("res", res);
					let _data = res.data[0][0];
					// let userData = await this.ajax.get("https://pbl.cocorobo.cn/api/pbl/selectUser/selectUser", { userid: _data.userid });
					// let _uorg = userData.data[0][0].org;
					this.account = _data.username;
					await this.getOrgData();

					if (this.allowOrgList.findIndex((i) => i.area) != -1) {
						let _index = this.allowOrgList.findIndex((i) => i.area);
						let _list = this.allowOrgList[_index].list;
						if (!_list.includes(this.OrgOptions[0].id)) {
							// 账号不可登录，请使用您的专属网址
							this.$message.error(this.lang.Accountcannot);
							this.wechatLogin();
							await loginOut();
							await this.logout();
							return;
						}
					} else {
						let mergedList = this.allowOrgList.reduce((acc, curr) => {
							return [...acc, ...curr.list];
						}, []);
						// if (
						// 	this.OrgOptions.find((i) => i.Uorg == this.org) &&
						// 	!_list.includes(
						// 		this.OrgOptions.find((i) => i.Uorg == this.org).id
						// 	)
						// ) {
						if (
							mergedList.includes(this.OrgOptions[0].id)
						) {
							// 账号不可登录，请使用您的专属网址
							this.$message.error(this.lang.Accountcannot);
							this.wechatLogin();
							await loginOut();
							await this.logout();
							return;
						}
					}
					let userjson = await getUser({ userid: _data.userid });
					
					const currentDate = new Date();
						if (
							userjson.data[0][0].isLogin1 == 2 ||
							(userjson.data[0][0].isLogin1 &&
							userjson.data[0][0].isLogin1 != 1 &&
							userjson.data[0][0].isLogin1 != 2 &&
							new Date(userjson.data[0][0].isLogin1) < currentDate) ||
							userjson.data[0][0].isLogin2 == 2 ||
							(userjson.data[0][0].isLogin2 != 1 &&
							userjson.data[0][0].isLogin2 != 2 &&
							new Date(userjson.data[0][0].isLogin2) < currentDate) ||
							userjson.data[0][0].state != 1
						) {
							console.log('666');
							this.loading = false;
							this.$message.error(this.lang.accAbnormal)

							return;
						} 

					console.log("userjson", userjson);
					if (_data.active === 1) {
						window.localStorage["identity"] = JSON.stringify(_data.identity);
						window.topU.U.UF.Cookie.set("cocoroboLoginType=2");
						window.topU
							? (window.topU.US.userInfo = _data)
							: (window.parent.US.userInfo = _data);
						await this.login();
						if (
							userjson.data[0][0].type == 1 &&
							userjson.data[0][0].role == 1 &&
							userjson.data[0][0].rrole == 1 &&
							this.allowOrgList.findIndex((i) => i.area) != -1
						) {
							if (this.urlForm === 'desktop') {
								window.location.href=`cocorobo://auth/callback?apiKey=${userjson.data[0][0].apikey}&state=${this.urlState}&userid=${userjson.data[0][0].userid}&username=${userjson.data[0][0].username}&schoolname=${userjson.data[0][0].schoolName}`;
							} else {
								this.$router.push({ path: "/kanban" });
							}
						} else {
							if (this.urlForm === 'desktop') {
								window.location.href=`cocorobo://auth/callback?apiKey=${userjson.data[0][0].apikey}&state=${this.urlState}&userid=${userjson.data[0][0].userid}&username=${userjson.data[0][0].username}&schoolname=${userjson.data[0][0].schoolName}`;
							} else {
								this.$router.push({
									path: this.redirect || "/",
									type: this.cocoNoteType 
								});
							}
						}
						// 浏览器缓存去除随机码登录信息
						window.sessionStorage.removeItem("stuInfoCode");
						this.$message.success(this.lang.Loginsuccessful);

						this.addOp3(
							"1",
							"",
							{ type: this.prefixL + (userjson.data[0][0].type == 1 ? '_teacher' : '_student') + "login" },
							"success",
							_data.userid
						);
					} else {
						this.$message.error(this.lang.Loginfailed);
					}

					this.loading = false;
				})
				.catch((err) => {
					console.log("错误信息", err.response);
					if (err && err.response && err.response.status === 401) {
						this.loginType = "bind";
					}
				});

			//
		},
		backSteps() {
			this.steps = 1;
			this.account = "";
			this.password = "";
			this.stuInfoCode = {};
		},
		// 随机码登录
		nextSteps() {
			if (!this.SuffixData) {
				this.$message.error(
					this.prefixL == "liyuan_"
						? this.lang.choosecampus
						: this.lang.enterorgnumber
				);
				return;
			}
			this.nextStepsLoading = true
			let reg = /^\d+$/;
			if (!reg.test(this.icode)) {
				this.$message.error(this.lang.codecorrectly);
				this.nextStepsLoading = false
				return;
			}

			let params = [
				{
					functionName: API_CONFIG.ajax_selectCourseByIc2.functionName, // 调用存储过程的名称
					code: this.icode,
					oid: this.SuffixData,
				},
			];

			this.$ajax
				.post(API_CONFIG.baseUrl, params)
				.then(async (res) => {
					if (res.data.length && res.data[0].length) {
						this.codeRes = res.data[0][0];
						this.courseId = res.data[0][0].courseId;
						let oid = res.data[0][0].organizeid;
						await this.getClassName(res.data[0][0].classid)
						this.getClass(res.data[0][0].classid,oid);
					} else {
						this.nextStepsLoading = false
						this.$message.error(this.lang.codenotexist);
					}
				})
				.catch((err) => {
					this.nextStepsLoading = false

					console.error(err);
				});
		},
		// 随机码2登录
		nextSteps2() {
			if (this.SuffixData.length < 5) {
				this.$message.error(this.lang.enterCorrectcode);
				return;
			}

			let suf = this.SuffixData.slice(0,4) //组织号
			let cod = this.SuffixData.slice(4)    //课程识别码

			this.icode = cod		
			console.log('suf',suf);
			console.log('cod',cod);

			this.nextStepsLoading = true
			let reg = /^\d+$/;
			if (!reg.test(cod)) {
				this.$message.error(this.lang.codecorrectly);
				this.nextStepsLoading = false
				return;
			}

			let params = [
				{
					functionName: API_CONFIG.ajax_selectCourseByIc2N.functionName, // 调用存储过程的名称
					// code: this.icode,
					// oid: this.SuffixData,
					code: cod,
					oid: suf,
				},
			];

			this.$ajax
				.post(API_CONFIG.baseUrl, params)
				.then(async (res) => {
					if (res.data.length && res.data[0].length) {
						this.codeRes = res.data[0][0];
						this.courseId = res.data[0][0].courseId;
						let oid = res.data[0][0].organizeid;
						await this.getClassName(res.data[0][0].classid)
						this.getClass(res.data[0][0].classid,oid);
					} else {
						this.nextStepsLoading = false
						this.$message.error(this.lang.codenotexist);
					}
				})
				.catch((err) => {
					this.nextStepsLoading = false

					console.error(err);
				});
		},
		async getClassName(val){
			let params = [
				{
					functionName: API_CONFIG.ajax_selectliyuanCodename.functionName, // 调用存储过程的名称
					cid: val,
				},
			];
			return new Promise((resolve, reject) => {
				this.$ajax
				.post(API_CONFIG.baseUrl, params)
				.then((res) => {
					this.codeClassName = res.data[0][0].name
					resolve(1)
				})
				.catch((err) => {
					reject(err)
					console.error(err);
				});
			})
			
		},
		// 根据随机码获取学生
		getClass(classId,oid) {
			let params = [
				{
					functionName: API_CONFIG.ajax_selectSnameByCidAndOid.functionName, // 调用存储过程的名称
					cid: classId,
					oid:oid
				},
			];

			this.$ajax
				.post(API_CONFIG.baseUrl, params)
				.then((res) => {
					// this.classJuri = res.data[0];

					this.classJuri = this.groupByName(res.data[0])
					// console.log('this.classJuri',this.classJuri);
					this.nextStepsLoading = false
						
					this.steps = 2;
				})
				.catch((err) => {
					this.nextStepsLoading = false

					console.error(err);
				});
		},
		// 拼音排序
		groupByName(list) {
			let alphabetArray = Array.from({length: 26}, (_, i) => ({
				id: String.fromCharCode(65 + i),
				child: []
			}));
			alphabetArray.push({id:'#',child:[]})
			console.log('alphabetArray1',alphabetArray);

			list.forEach(e => {
				let l = pinyin(e.username, { style: pinyin.STYLE_NORMAL }).join('')[0].toLocaleUpperCase()
				// console.log('l',l);
				
				if (this.uppercaseAlphabet.includes(l)) {
					alphabetArray.forEach(k=>{
						if (l == k.id) {
							k.child.push(e)
						}
					})
				}else{
					alphabetArray[alphabetArray.length-1].child.push(e)
				}
				
			});
			alphabetArray = alphabetArray.filter(e=>e.child.length)
			console.log('alphabetArray',alphabetArray);
			
			return alphabetArray
			// return list.sort((a, b) => {
			// 	const pinyinA = pinyin(a.username, { style: pinyin.STYLE_NORMAL }).join('');
			// 	const pinyinB = pinyin(b.username, { style: pinyin.STYLE_NORMAL }).join('');
			// 	return pinyinA.localeCompare(pinyinB);
			// });
		},
		// 选择学生账户
		selAcc(val) {
			console.log("val", val);

			this.account = val.accountNumber;
			this.password = val.userpassword;
			this.stuInfoCode = val;
		},
		// 根据随机码获取的账号登录到课程里面
		async loginCode() {
			// let courseid = this.courseId;
			try {
				await this.$confirm(
					this.lang.loginaccount.replace(/\*/g, this.stuInfoCode.username),
					this.lang.tip,
					{
						confirmButtonText: this.lang.confirm,
						cancelButtonText: this.lang.Cancel,
						type: "warning",
					}
				);
				this.loading = true;

				console.log("this.stuInfoCode", this.stuInfoCode);
				// let loginData=JSON.stringify({openid: this.stuInfoCode.userid,edu: true})

				let params = {
					geetest_challenge: "",
					geetest_validate: "",
					geetest_seccode: "",
					openid: this.stuInfoCode.userid,
					edu: true,
				};
				axios.defaults.withCredentials = true;
				axios
					.post(this.userRequest, qs.stringify(params))
					.then(async (res) => {
						console.log("res", res);
						this.loading = false;

						let _data = res.data[0][0];
						let userjson = await getUser({ userid: _data.userid });

						const currentDate = new Date();
						if (
							userjson.data[0][0].isLogin1 == 2 ||
							(userjson.data[0][0].isLogin1 &&
							userjson.data[0][0].isLogin1 != 1 &&
							userjson.data[0][0].isLogin1 != 2 &&
							new Date(userjson.data[0][0].isLogin1) < currentDate) ||
							userjson.data[0][0].isLogin2 == 2 ||
							(userjson.data[0][0].isLogin2 != 1 &&
							userjson.data[0][0].isLogin2 != 2 &&
							new Date(userjson.data[0][0].isLogin2) < currentDate) ||
							userjson.data[0][0].state != 1
						) {
							console.log('666');
							this.loading = false;
							this.$message.error(this.lang.accAbnormal)

							return;
						}
						console.log("userjson", userjson);
						if (_data.active === 1) {
							window.localStorage["identity"] = JSON.stringify(_data.identity);

							window.topU.U.UF.Cookie.set("cocoroboLoginType=2");
							window.topU
								? (window.topU.US.userInfo = _data)
								: (window.parent.US.userInfo = _data);
							await this.login();
							this.$message.success(this.lang.Loginsuccessful);
							// 浏览器缓存添加随机码登录信息
							window.sessionStorage.setItem("stuInfoCode", JSON.stringify(this.icode));
							
							if (this.urlForm === 'desktop') {
								window.location.href=`cocorobo://auth/callback?apiKey=${userjson.data[0][0].apikey}&state=${this.urlState}&userid=${userjson.data[0][0].userid}&username=${userjson.data[0][0].username}&schoolname=${userjson.data[0][0].schoolName}`;
							} else {
								this.$router.push({
									path: this.redirect || "/",
									query: { 
										courseid: this.cocoNoteType ? this.cocoNoteCid : this.courseId,
										type: this.cocoNoteType  
									},
								});
							}
							this.addOp3(
								"1",
								"",
								{ type: this.prefixL + "stuCode_login" },
								"success",
								this.stuInfoCode.userid
							);
						} else {
							this.$message.error(this.lang.Loginfailed);
						}
					})
					.catch((err) => {
						this.loading = false;
						console.error(err);
					});
			} catch (error) {
				this.loading = false;
				console.error("登录过程中出错:", error);
			}
		},
		// 获取荔园校区数据
		getData(val) {
			this.loginType = val;
			this.SuffixData = "";
			this.icode = "";
			if (this.prefixL != 'liyuan_' || val == 'code2') return
			this.Codeloading = true;
			let params = [
				{
					functionName: API_CONFIG.select_liYuanCampus.functionName, // 调用存储过程的名称
					org: "3823a6a5-1b6e-11f0-a66a-005056924926", //组织id
				},
			];

			// 发起请求
			this.$ajax
				.post(API_CONFIG.baseUrl, params)
				.then((res) => {
					let data = res.data[0];
					console.log(data);

					this.CodeOptions = data;
					this.Codeloading = false;
				})
				.catch((err) => {
					this.Codeloading = false;
					console.error("请求失败，错误信息：", err);
				});
		},
	},
	mounted() {
	console.log('更新');
	
		let _this = this;
		window.addEventListener("message", function (e) {
			// 监听 message 事件
			console.log("longin", e);
			if (e.data && e.data.method == "getOpenId") {
				console.log("e", e);
				console.log("e.data.code", e.data.code);
				console.log("_this.loginType", _this.loginType);

				if (e.data.code == 200) {
					_this.getOpenId(e.data.data.openid);
				} else {
					_this.$message.error(this.lang.Scanagain);
					_this.wechatLogin();
				}
			}
		});
		if (this.cocoNoteCid) {
			this.nextStepsLoading = true
			this.cocostulog()
		}
		if (this.cocoNoteType === 'coconote') {
			this.typePageName = '跨学科学习';
		}else if (this.cocoNoteType === 'person') {
			this.typePageName = '拔尖人才';
		}else if (this.cocoNoteType === 'learning') {
			this.typePageName = '个性化学习';
		}else if (this.cocoNoteType === 'classroomOb') {
			this.typePageName = '课堂教学评价';
		}
		if (this.$route.query["orgnum"] && this.$route.query["classcode"]) {
			this.SuffixData = this.$route.query["orgnum"];
			this.icode = this.$route.query["classcode"];
			this.nextSteps();
		}
		this.getLoading();
		this.getOrdOidData();
		const m = window.location.href.match(/[?&]org=([^&'"]+)/);
		this.orgid = m ? decodeURIComponent(m[1]) : '';
		try {
			if(window.topU.location.href.includes('ssyaiedu')) {
				this.orgid ='aa45263b-96fc-11f1-9985-005056924926'
			}
		} catch (error) {
			if(window.top.location.href.includes('ssyaiedu')) {
				this.orgid ='aa45263b-96fc-11f1-9985-005056924926'
			}
		}
		


	},
};
</script>
<style scoped>
.loginPage {
	width: 100vw;
	height: 100vh;
	height: 100dvh;
	background-color: white;
	display: flex;
	position: relative;
	align-items: center;
	justify-content: center;
	overflow: hidden;
}

.lp_left {
	max-width: 50%;
	width: 50%;
	max-height: 100%;
	height: 100%;
	overflow: hidden;
	box-sizing: border-box;
	min-width: 0;
	flex-shrink: 1;
	border-radius: 0 10% 0 0;
}

.lp_left > img {
	width: 100%;
	height: 100%;
	display: block;
	object-fit: cover;
	/* 缩放时锚定左上角，顶部和左侧完整展示，右侧/底部可裁切 */
	object-position: left top;
}

.lp_right {
	width: 50%;
	min-width: 520px;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: safe center;
	/* position: relative; */
	box-sizing: border-box;
	overflow-x: hidden;
	overflow-y: auto;
	-webkit-overflow-scrolling: touch;
}
.lp_right_mobile{
	margin-top: 35vh;
	align-items: flex-start;
}
.logIdy{
	display: flex;
	flex-direction: column;
	gap: 20px;
	/* padding: 30px 0 306px; */
	box-sizing: border-box;
}
/* 平板 / 高度不足时从顶部排布，避免居中裁切顶部 */
@media (max-width: 1024px), (max-height: 800px) {
	/* .lp_right {
		align-items: flex-start;
		padding-top: 0;
	} */
	.lp_right_mobile{
		margin-top: 30px;
	}
	.lp_r_b_logo_name{
		width: 80%;
	}
}

.Version {
	background: #f0f4fa;
	/* border-radius: 50%; */
	border-radius: 50px 50px 50px 50px;
	/* border: .5px #cad1dc solid; */
	position: absolute;
	color: #060e17;
	padding: 8px 15px;
	box-sizing: border-box;
	top: 30px;
	right: 20px;
	cursor: pointer;
}
.lp_r_box {
	width: 500px;
	height: auto;
	box-sizing: border-box;
	padding: 20px;
}

.lp_r_b_logo {
	display: flex;
	align-items: center;
}

.lp_r_b_logo > span {
	margin-left: 15px;
	font-weight: bold;
	font-size: 18px;
}

.lp_r_box > span {
	font-size: 46px;
	font-weight: bold;
	margin: 40px 0;
	display: block;
}

.lp_r_b_formArea {
	width: 100%;
	height: 250px;
	margin-bottom: 40px;
}

.fa_input {
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	/* align-items: center; */
	justify-content: center;
}

.fa_i_item {
	width: 100%;
	height: 70px;
	margin-bottom: 30px;
}
.psdg >>> .el-input__suffix{
	display: flex;
	align-items: center;
}
.psdg >>> .el-input__inner{
	border: none;
	border-radius: 8px;
}
.fa_i_item > span {
	font-size: 16px;
	color: rgba(0, 0, 0, 0.9);
	font-weight: 600;
}

.fa_i_item > div {
	width: 100%;
	height: 40px;
	border: solid 1px rgba(213, 213, 213, 1);
	margin-top: 5px;
	border-radius: 8px;
	transition: 0.5s;
}

.fa_i_item > div > input {
	width: 100%;
	height: 100%;
	border: none;
	outline: none;
	text-indent: 1em;

	color: #000;
	font-size: 14px;
	background: none;
}

.fa_i_item > div >>> .el-select {
	width: 100%;
	height: 100%;
}

.fa_i_item > div >>> .el-select input {
	border: none;
	outline: none;
	background: none;
	text-indent: 1em;
	font-size: 14px;
	height: 40px;
	padding-left: 0;
	color: #000;
}

/* .fa_i_item > input {
	width: 100%;
	height: 45px;
	border: solid 1px rgba(213, 213, 213, 1);
	outline: none;
	border-radius: 8px;
	margin-top: 15px;
	text-indent: 1em;
	transition: 0.5s;
	color: #000;
	font-size: 16px;
} */

.fa_i_item > div >>> input::placeholder {
	color: rgba(142, 142, 147, 1);
}

.fa_i_item > div:focus-within {
	border-color: #006afe;
}

.fa_weChat {
	width: 300px;
	height: 300px;
	margin: 0 auto;
	display: flex;
	align-items: center;
	justify-content: center;
}

.fa_weChat > .QRcode {
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	/* background-color: black; */
}

.lp_r_b_btn {
	width: 100%;
	height: 45px;
	background-color: rgba(0, 106, 254, 1);
	border-radius: 10px;
	display: flex;
	justify-content: center;
	align-items: center;
	color: #fff;
	cursor: pointer;
	transition: 0.3s;
}

.lp_r_b_btn:hover {
	background-color: rgb(3, 87, 206);
}

.backBtn {
	background-color: #d9d9d9;
	color: #000;
}

.backBtn:hover {
	background-color: #adadad;
}

.lp_r_b_line {
	width: 100%;
	height: 20px;
	margin: 40px 0;
	display: flex;
	justify-content: center;
	align-items: center;
}

.lp_r_b_line > div {
	width: calc(100% / 2 - 70px);
	height: 1px;
	background-color: #e7e7e7;
}

.lp_r_b_line > span {
	display: flex;
	margin: 0 20px;
}

.lp_r_b_iconBtn {
	width: 100%;
	height: 40px;
	display: flex;
	justify-content: center;
}

.lp_r_b_iconBtn > div {
	width: 32px;
	height: 32px;
	cursor: pointer;
	margin: 0 20px;
}

.lp_r_b_iconBtn > div > img {
	width: 100%;
	height: 100%;
}

.btn_box {
	display: flex;
	gap: 10px;
}
.stuPage {
	margin: 10px;
	max-height: 500px;
	display: flex;
	flex-direction: column;
	gap: 20px;
}
.Abar{
	display: flex;
	position: relative;
	flex-direction: column;
	gap: 5px;
	width: 20px;
	background: #f0f4fa;
	align-items: center;
	border-radius: 12px;
    padding: 7px 0;
    overflow: auto;
	font-size: 14px;
}
.Abar span{
	cursor: pointer;
}
/* .Abar {
  overflow-y: auto;
  padding-right: 8px; 
} */
/* 隐藏滚动条但保留功能 */
.Abar::-webkit-scrollbar { width: 1px; } 
/* .Abar { scrollbar-width: none; } */

.stuListTit{
	position: absolute;
	top: -35px;
	left: 0;
	background: #f5faff;
	box-sizing: border-box;
	width: 100%;
	padding: 4px 7px;
}
.nameList{
    overflow: auto;
    display: flex;
    flex-direction: column;
	padding-top: 35px;
	box-sizing: border-box;
    gap: 45px;
	flex: 1;
}
.stuList {
	display: -moz-grid;
	display: grid;
	/* height: 100%;  */
	grid-template-columns: repeat(4, 1fr);
	gap: 10px;
	position: relative;
}

.nameList::-webkit-scrollbar { width: 0px; } 
.nameList { scrollbar-width: none; }

.nameModule {
	padding: 3px 15px;
	border-radius: 3px;
	-webkit-line-clamp: 1;
	line-height: 22px;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
	border: 1px #e7e7e7 solid;
	text-align: center;
	cursor: pointer;
}
.stuback {
	background: #006afe;
	color: #fff;
}

.backIDy{
	font-size: 14px;
	font-weight: normal;
	cursor: pointer;
	flex-shrink: 0;
}
.logIdImg{
	background: #F1F2F6;
	width: 50%;
	min-width: 100px;
	height: 120px;
	padding: 10px;
	box-sizing: border-box;
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 5px;
	flex-direction: column;
	border-radius: 10px;
	cursor: pointer;
}
.logIdImg img{
	height: 50px;
	width: 50px;
}
.tep{
	max-height: 400px;display: flex;gap: 10px;
}
/* .backWin{ */
/* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3); */
/* }  */
</style>
